import type { AddressItem } from '@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { apiAddAddress, apiDeleteAddress, apiGetAddresses, apiSetDefaultAddress, apiUpdateAddress } from '@/api/useShopApi'

/** 兑换确认页临时选中的地址 id */
const selectedId = ref('')

export const useAddressStore = defineStore('address', () => {
  const list = ref<AddressItem[]>([])
  const loaded = ref(false)

  /** 获取地址列表（默认地址排最前） */
  async function fetchAddresses(force = false) {
    if (loaded.value && !force)
      return
    list.value = await apiGetAddresses()
    loaded.value = true
  }

  /** 新增地址 */
  async function addAddress(address: Omit<AddressItem, 'id'>) {
    const created = await apiAddAddress(address)
    await fetchAddresses(true)
    return created
  }

  /** 更新地址 */
  async function updateAddress(address: AddressItem) {
    await apiUpdateAddress(address)
    await fetchAddresses(true)
  }

  /** 删除地址 */
  async function removeAddress(id: string) {
    await apiDeleteAddress(id)
    await fetchAddresses(true)
  }

  /** 设为默认地址 */
  async function setDefault(id: string) {
    await apiSetDefaultAddress(id)
    await fetchAddresses(true)
  }

  /** 获取默认地址 */
  function getDefault(): AddressItem | null {
    return list.value.find(item => item.isDefault) || list.value[0] || null
  }

  function getById(id: string): AddressItem | null {
    return list.value.find(item => item.id === id) || null
  }

  /** 兑换确认页：选中地址 */
  function selectAddress(id: string) {
    selectedId.value = id
  }

  function getSelected(): AddressItem | null {
    return getById(selectedId.value) || getDefault()
  }

  return {
    list,
    loaded,
    fetchAddresses,
    addAddress,
    updateAddress,
    removeAddress,
    setDefault,
    getDefault,
    getById,
    selectAddress,
    getSelected,
  }
}, { persist: true })
